module.exports = [
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 369.1
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 347.83
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 319.93
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 277.1
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 260.5
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 272.83
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 295.95
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 182.3
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 190.4
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 186.1
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 180.43
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 180.17
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 194.57
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 208.5
  }
]
